export const ERROR_MESSAGES = {
  DEFAULT: 'Oeps, er ging iets fout. Kan je het later nog eens proberen?'
};
